import "../styles/CopyRight.scss";

function CopyRight() {
  return (
    <div className="copy-right">
      <p className="copy-right__text">Designed And Developed By m0hammadr3za</p>

      <a href="#!" className="copy-right__link">
        My Github
      </a>
    </div>
  );
}

export default CopyRight;
